import { RoundedButton } from "generalComponents/Button";
import ModalManagement from "generalComponents/CustomModal";
import useCartStore, { useCartSumTotal } from "store/cartStore";
import CartItem from "./CartItem";

// const appBaseUrl = process.env.REACT_APP_APP_BASE_URL;

const CartModal = ({ id }) => {
  const cart = useCartStore((state) => state.cart);
  const cartsumTotal = useCartSumTotal();

  return (
    <ModalManagement
      id={id}
      title={"Cart"}
      className={
        "relative p-0 min-h-[600px] max-h-[90svh] overflow-hidden no-scrollbar"
      }
      titleClass={"p-7 mb-0"}
    >
      <div className="relative">
        <div className="pb-[500px] sm:pb-[200px] relative grid gap-3 px-7 max-h-[800px] overflow-scroll no-scrollbar">
          {cart?.map((item, index) => (
            <CartItem key={index} {...item} />
          ))}
        </div>

        <div className="bg-white shadow-[0_-10px_15px_-3px_rgb(0_0_0/0.1)] w-full fixed bottom-0 p-5">
          <div className="flex justify-between items-center">
            <p className="text-purpleOverlay font-semibold">Total</p>
            <p className="text-3xl font-semibold text-purpleBg">
              <span className="text-orangeBg">₦</span>
              {cartsumTotal?.toLocaleString()}
            </p>
          </div>
          <RoundedButton
            onClick={() => null}
            className="py-5 mt-3 w-full text-base flex justify-center items-center gap-2.5 rounded-[40px] font-semibold"
          >
            Checkout
          </RoundedButton>
        </div>
      </div>
    </ModalManagement>
  );
};

export default CartModal;
